import { FileModuleApiService } from '~packages/epk-front-shared/api-client';
import { Mode } from '~packages/json-api/client';

import getConstants from '@/constants';

const { isModeDevelopment } = getConstants();

const constructorParams = {
  className: 'ConvertersApiService',
  mode: isModeDevelopment ? Mode.Production : Mode.Production,
  needInit: false,
};

export default class ConvertersApiService extends FileModuleApiService {
  constructor() {
    super(constructorParams);
  }
}
